import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { Category } from "../../categories.types";
import { ApiRoutesCategories } from "./../../constants";
import { DeleteCategoryRequest } from "./deleteCategory.types";

export const requestDeleteCategory = async (
  body: DeleteCategoryRequest
): Promise<Category> => {
  return await instance.delete(buildUrl(ApiRoutesCategories.Category, body.id));
};
